import React from 'react';
import {
	Box,
} from '@mui/material';
import BackgroundImage from './BackgroundImage';

function BackgroundImageBox({ children, top = "0%", margin = 0, backgroundColor = "black", src = null }) {
  const allSizeSx = {
    height: '100%',
    width: '100%'
  };
  return (
    <Box sx={{ ...allSizeSx, backgroundColor }} >
      <Box sx={{ position: 'relative', margin }}>
	      <BackgroundImage src={src} />

	      <Box sx={{ height: '100%', width: '100%', position: 'absolute', top, left: 0, textAlign: 'center' }}>{children}</Box>
	     </Box>
    </Box>
  );
}

export default BackgroundImageBox;